module.exports = __webpack_public_path__ + "static/media/contract.57f44c7e.png";